'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

var _capeStyle = require('cape-style');

var _capeStyle2 = _interopRequireDefault(_capeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  base: (0, _capeStyle2.default)('ba br1 p1 m1'),
  color: {
    danger: '#a94442',
    info: '#31708f',
    success: '#3c763d',
    warning: '#8a6d3b'
  }
};
function getStyle(_ref) {
  var color = _ref.color,
      type = _ref.type,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;

  var baseColor = (0, _tinycolor2.default)((0, _get3.default)(color, type, styles.color[type]));
  var colorStyles = {
    color: baseColor.toString(),
    backgroundColor: baseColor.lighten(50).toString(),
    borderColor: baseColor.darken(50).toString()
  };
  return (0, _merge3.default)({}, styles.base, colorStyles, style);
}

function Alert(props) {
  var children = props.children,
      type = props.type;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('alert', type), role: 'alert', style: getStyle(props) },
    children
  );
}
Alert.defaultProps = {
  color: styles.color
};
var colorObjProps = _propTypes2.default.shape({
  r: _propTypes2.default.number, g: _propTypes2.default.number, b: _propTypes2.default.number
});
Alert.propTypes = {
  color: _propTypes2.default.oneOfType([colorObjProps, _propTypes2.default.string]).isRequired,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  type: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger'])
};

exports.default = Alert;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/AlertEl.js
// module id = 668
// module chunks = 0